/** Replace inputs only in html2canvas's clone to avoid clipping Japanese input text. */
export function prepareReceiptTextForCapture(clonedDocument: Document): void {
  const receipt = clonedDocument.getElementById('transactionReceipt');
  if (!receipt) return;
  receipt.querySelectorAll<HTMLInputElement>('input').forEach(input => {
    const text = clonedDocument.createElement('span');
    text.className = input.className;
    text.style.cssText = input.style.cssText;
    text.textContent = input.value;
    const style = clonedDocument.defaultView?.getComputedStyle(input);
    if (style) {
      for (const property of ['font-family', 'font-size', 'font-weight', 'font-style', 'letter-spacing',
        'color', 'width', 'text-align', 'border-bottom', 'margin-bottom']) {
        text.style.setProperty(property, style.getPropertyValue(property));
      }
    }
    text.style.display = 'inline-block';
    text.style.height = 'auto';
    text.style.lineHeight = '1.5';
    text.style.verticalAlign = 'baseline';
    text.style.whiteSpace = 'pre';
    input.replaceWith(text);
  });
}
